exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.delayOrderColor, .delayOrderColor > td, .delayOrderColor:hover, .delayOrderColor > td:hover {\n  background-color: #ffefef !important;\n}\n.delayTwoHours, .delayTwoHours > td, .delayTwoHours:hover, .delayTwoHours > td:hover {\n  background-color: #f7d5d5 !important;\n}\ntr.delayOrderColor.table-active:hover td {\n    background-image: none !important;\n}\ntr.delayTwoHours.table-active:hover td {\n    background-image: none !important;\n}\n.m-order-main .mx-datepicker {\n\twidth: auto !important;\n}\n.m-order-main .mx-datepicker input {\n\tpadding-right: 25px !important;\n}\n", ""]);

// exports
